var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53809 0C1.13643 0.000202901 0.000202179 1.13643 0 2.53809V11.7695C0.000162125 13.1712 1.13641 14.3074 2.53809 14.3076H3.69238V15.5938C3.69257 16.9226 4.76975 17.9999 6.09863 18H14.5381C16.4498 18 18 16.4498 18 14.5381V6.09863C17.9999 4.76975 16.9226 3.69257 15.5938 3.69238H14.3076V2.53809C14.3074 1.13643 13.1712 0.000202901 11.7695 0H2.53809ZM15.5938 5.07715C16.1579 5.07733 16.6151 5.53445 16.6152 6.09863V14.5381C16.6152 15.6851 15.6851 16.6152 14.5381 16.6152H6.09863C5.53445 16.6151 5.07733 16.1579 5.07715 15.5938V14.3076H11.7695C13.1712 14.3074 14.3075 13.1712 14.3076 11.7695V5.07715H15.5938ZM11.7695 1.38477C12.4065 1.38497 12.9226 1.90113 12.9229 2.53809V11.7695C12.9227 12.4065 12.4065 12.9226 11.7695 12.9229H2.53809C1.90111 12.9226 1.38493 12.4065 1.38477 11.7695V2.53809C1.38497 1.90113 1.90113 1.38497 2.53809 1.38477H11.7695Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyContent);
export default __webpack_public_path__ + "static/media/CopyContent.679754540261d3e3ec3856e6d5241f79.svg";
export { ForwardRef as ReactComponent };